var map = {
	"./AlaskaBlue.png": 24970,
	"./Anise.png": 84358,
	"./AppleGreen.png": 57771,
	"./Azure.png": 75689,
	"./Bordeaux.png": 95594,
	"./Buff.png": 35545,
	"./Champagne.png": 1532,
	"./CharcoalGray.png": 73970,
	"./ChestnutBrown.png": 48326,
	"./CloudWhite.png": 74924,
	"./Cream.png": 17394,
	"./DawnPink.png": 98922,
	"./DefaultBottom.png": 94547,
	"./DefaultLightGrey.png": 995,
	"./DefaultTop.png": 58046,
	"./Eggshell.png": 25805,
	"./FeltGrey.png": 85478,
	"./Ivory.png": 20035,
	"./Ivy.png": 11922,
	"./LightBlue.png": 64241,
	"./LightGreen.png": 1072,
	"./Lilac.png": 40166,
	"./Lily.png": 58759,
	"./blank.png": 72142,
	"./doubleMat.png": 65796,
	"./singleMat.png": 76086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22374;